import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './TypeCleaning.module.scss';
import {stepperInfoActions} from "../../store/slices/stepperInfoSlice";
import {serviceTypesActions} from "../../store/slices/serviceTypesSlice";

const TypeCleaning = () => {
    const dispatch = useDispatch();
    const {type_cleaning} = useSelector(state => state.stepperInfo);
    const {serviceTypes} = useSelector(state => state.serviceTypes);

    const handleSelectTypeCleaning = (cleaning) => {
        dispatch(stepperInfoActions.setTypeCleaning(cleaning));
        dispatch(stepperInfoActions.removeAllServices());
    }

    useEffect(() => {
        const getAllServiceTypes = async () => {
            try {
                await dispatch(serviceTypesActions.getAll());
            } catch (error) {
                console.error(error);
            }
        }

        getAllServiceTypes();
    }, []);

    return (
        <div className={styles.typeCleaning}>
            <div className={styles.typeCleaning_description}>
                <p>Тип прибирання <sup>*</sup></p>
            </div>

            <div className={styles.typeCleaning_buttons}>
                {serviceTypes.map((serviceType, index) =>
                    <button
                        key={index}
                        onClick={() => handleSelectTypeCleaning(serviceType?.name)}
                        className={`${styles.typeCleaning_buttons_button}
                        ${(type_cleaning === serviceType?.name) ? styles.selected : ''}`}
                    >{serviceType?.name}
                    </button>)}
            </div>
        </div>
    );
};

export default TypeCleaning;
